"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RescheduleFlowMobileLayout = void 0;
const styles_1 = require("./styles");
const react_1 = __importDefault(require("react"));
const SidebarContentLayout_1 = require("./SidebarContentLayout");
const ContentSidebarFooterLayout_1 = require("./ContentSidebarFooterLayout");
function RescheduleFlowMobileLayout({ children, sidebar, banner, footer, isErrorOrRescheduled }) {
    return (react_1.default.createElement(styles_1.MobileContainer, null,
        react_1.default.createElement(styles_1.MobileMainContent, { className: "mobile-main-content", isErrorOrRescheduled: isErrorOrRescheduled }, !isErrorOrRescheduled ? (react_1.default.createElement(SidebarContentLayout_1.SidebarContentLayout, { sidebar: sidebar }, children)) : (react_1.default.createElement(ContentSidebarFooterLayout_1.ContentSidebarFooterLayout, { sidebar: sidebar, footer: footer }, children))),
        banner));
}
exports.RescheduleFlowMobileLayout = RescheduleFlowMobileLayout;
//# sourceMappingURL=RescheduleFlowMobileLayout.js.map